class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('a');

    if (!this.button) return;

    this.loading = false;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading) {
            this.loadMoreProducts();
          }
        });
      },
      {
        rootMargin: '800px',
      }
    );

    this.observer.observe(this);
  }

  async loadMoreProducts() {
    if (this.loading) return;

    this.loading = true;

    const nextPage = this.button.getAttribute('href');

    if (!nextPage) return;

    this.classList.add('loading');

    try {
      const response = await fetch(nextPage);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, 'text/html');

      const newProducts = html.querySelector('#product-grid');
      const currentProducts = document.querySelector('#product-grid');

      if (newProducts && currentProducts) {
        currentProducts.insertAdjacentHTML(
          'beforeend',
          newProducts.innerHTML
        );
      }

      const newPagination = html.querySelector('infinite-scroll');

      if (newPagination && newPagination.innerHTML.trim() !== '') {
        this.innerHTML = newPagination.innerHTML;
        this.button = this.querySelector('a');

        this.loading = false;

        this.observer.observe(this);
      } else {
        this.remove();
      }
    } catch (error) {
      console.error('Infinite Scroll Error:', error);
    }

    this.classList.remove('loading');
  }
}

customElements.define('infinite-scroll', InfiniteScroll);